/* mh-pdp.js — Hardly Common product page behaviour.
   Written for the mh-* markup in sections/main-product.liquid. Does not
   touch product-page.js, which still drives the Atelier / earring /
   bracelet commission modules and other templates. */
(function () {
  'use strict';

  /* ── Similar Items ──
     Shopify only fills `recommendations` through the Section Rendering API,
     so the section ships a server-side fallback and we swap in the real
     recommendations here. Lives outside the PDP root guard because the rail
     is its own section. */
  var rail = document.querySelector('[data-mh-recs]');
  if (rail && rail.dataset.url && window.fetch) {
    fetch(rail.dataset.url)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html')
                      .querySelector('[data-mh-recs]');
        if (fresh && fresh.querySelector('.mh-card')) rail.innerHTML = fresh.innerHTML;
      })
      .catch(function () { /* keep the server-rendered fallback */ });
  }

  var root = document.querySelector('[data-mh-pdp]');
  if (!root) return;

  var titleEl = root.querySelector('.mh-h1');

  /* ── Help button: name the piece in the advisor drawer ──
     The drawer itself is opened by advisor-modal.liquid, which binds
     [data-advisor-trigger]. Its own lookup is
       document.querySelector('.product__title, h1.product-title, [data-product-title]')
     and on this theme the wishlist heart in the gallery ALSO carries
     data-product-title and sits earlier in the DOM, so that returns an icon
     button with empty textContent and the drawer reads "This product".
     Set the chip here instead. This listener is registered first (this file
     is deferred; the modal binds on DOMContentLoaded) and the modal only
     writes the chip when its own lookup succeeds, so it will not overwrite. */
  var help = root.querySelector('.mh-help');
  if (help && titleEl) {
    help.addEventListener('click', function () {
      var chip = document.getElementById('adv-chip-name');
      if (chip) chip.textContent = titleEl.textContent.trim();
    });
  }

  /* ── Atelier: make sure a buy button exists on load ──
     snippets/atelier-choice.liquid renders its CTA with style="display:none"
     and the hint "Select an option above", so on every Atelier product the
     page opened with no visible way to buy until the customer guessed to
     click a card. Choose the sensible default for them: the in-stock piece
     if there is one, otherwise the commission. Their own click handler does
     the rest, so this stays out of their file. */
  var atelierCta = document.getElementById('pp-atelier-cta');
  if (atelierCta && atelierCta.style.display === 'none') {
    var optCollection = document.getElementById('pp-opt-collection');
    var optCommission = document.getElementById('pp-opt-commission');
    var preferred = (optCollection &&
                     !optCollection.classList.contains('pp-atelier__option--unavailable'))
                     ? optCollection : optCommission;
    if (preferred) preferred.click();
  }

  /* ── variant selection ──
     Option buttons write into the hidden <select name="id">, which is what
     the product form actually submits. The select keeps id="pp-variant-id"
     because atelier-choice.liquid, earring-commission.liquid and
     bracelet-commission.liquid all look it up by that id. */
  var idSelect = root.querySelector('[data-mh-variant-id]');
  var variants = [];
  var raw = root.querySelector('[data-mh-variants]');
  try { variants = JSON.parse(raw.textContent); } catch (e) { variants = []; }

  function currentOptions() {
    return Array.prototype.map.call(
      root.querySelectorAll('[data-mh-option-group]'),
      function (g) {
        var on = g.querySelector('button[aria-pressed="true"]');
        return on ? on.getAttribute('data-mh-option-value') : null;
      }
    );
  }

  function matchVariant(opts) {
    for (var i = 0; i < variants.length; i++) {
      var v = variants[i], ok = true;
      for (var j = 0; j < opts.length; j++) {
        if (opts[j] !== null && v.options[j] !== opts[j]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }

  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '')
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  var priceEl = root.querySelector('[data-mh-price]');
  var stickyPrice = null;

  function applyVariant(v) {
    if (!v) return;
    if (idSelect) idSelect.value = v.id;

    if (priceEl) priceEl.textContent = money(v.price);
    if (stickyPrice) stickyPrice.textContent = money(v.price);

    var compare = root.querySelector('[data-mh-compare]');
    if (compare) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        compare.textContent = money(v.compare_at_price);
        compare.hidden = false;
      } else { compare.hidden = true; }
    }

    var btn = root.querySelector('[data-mh-add]');
    var label = root.querySelector('[data-mh-add-text]');
    if (btn && label) {
      btn.disabled = !v.available;
      label.textContent = v.available ? (btn.getAttribute('data-mh-label') || 'Add to Bag')
                                      : 'Sold Out';
    }

    var sku = root.querySelector('[data-mh-sku]');
    if (sku && v.sku) sku.textContent = 'SKU: ' + v.sku;

    if (history.replaceState) {
      var u = new URL(window.location.href);
      u.searchParams.set('variant', v.id);
      history.replaceState({}, '', u.toString());
    }
  }

  root.querySelectorAll('[data-mh-option-group]').forEach(function (group) {
    group.addEventListener('click', function (e) {
      var b = e.target.closest('button[data-mh-option-value]');
      if (!b || b.disabled) return;
      group.querySelectorAll('button').forEach(function (x) {
        x.setAttribute('aria-pressed', 'false');
      });
      b.setAttribute('aria-pressed', 'true');

      var sel = group.closest('.mh-selector');
      var out = sel ? sel.querySelector('[data-mh-readout]') : null;
      if (out) out.textContent = b.getAttribute('data-mh-option-value');

      applyVariant(matchVariant(currentOptions()));
    });
  });

  /* ── sticky buy bar, phones only ──
     The buy button sits near the top of a very long column; by the time a
     customer has read the specs and the policies it is far off screen. This
     brings it back once it scrolls away, showing the live price beside it.
     Built here rather than in Liquid so it works for the plain Add to Bag
     and for the Atelier CTA without duplicating either. */
  var realCta = root.querySelector('[data-mh-add]') || atelierCta;

  if (realCta && 'IntersectionObserver' in window) {
    var bar = document.createElement('div');
    bar.className = 'mh-stickybuy';

    stickyPrice = document.createElement('span');
    stickyPrice.className = 'mh-stickybuy__price';
    stickyPrice.textContent = priceEl ? priceEl.textContent.trim() : '';

    var stickyBtn = document.createElement('button');
    stickyBtn.type = 'button';
    stickyBtn.className = 'mh-btn mh-btn--primary';
    stickyBtn.textContent = 'Add to Bag';

    /* Clicking the bar clicks the real control, so there is one code path to
       the cart and no second form to keep in sync. The cart drawer in
       snippets/hc-cart-drawer.liquid intercepts the submit, so this opens the
       drawer rather than navigating to checkout. */
    stickyBtn.addEventListener('click', function () { realCta.click(); });

    bar.appendChild(stickyPrice);
    bar.appendChild(stickyBtn);
    root.appendChild(bar);

    var syncStickyLabel = function () {
      var live = root.querySelector('[data-mh-add-text]') ||
                 document.getElementById('pp-atelier-cta-label');
      if (live) stickyBtn.textContent = live.textContent.trim();
      stickyBtn.disabled = !!realCta.disabled;
    };
    syncStickyLabel();

    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        /* Only once the button has scrolled off the TOP of the screen. */
        var gone = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('mh-stickybuy--on', gone);
        if (gone) syncStickyLabel();
      });
    }, { threshold: 0 }).observe(realCta);
  }

  /* ── size guide ── */
  var guide = root.querySelector('[data-mh-guide]');
  if (guide && typeof guide.showModal === 'function') {
    var openBtn = root.querySelector('[data-mh-guide-open]');
    var closeBtn = guide.querySelector('[data-mh-guide-close]');
    if (openBtn) openBtn.addEventListener('click', function () { guide.showModal(); });
    if (closeBtn) closeBtn.addEventListener('click', function () { guide.close(); });
    guide.addEventListener('click', function (e) { if (e.target === guide) guide.close(); });
  }

  /* ── gallery zoom ── */
  var zoom = root.querySelector('[data-mh-zoom]');
  if (zoom && typeof zoom.showModal === 'function') {
    var zimg = zoom.querySelector('[data-mh-zoom-img]');
    var zclose = zoom.querySelector('[data-mh-zoom-close]');
    root.querySelectorAll('[data-mh-zoom-open]').forEach(function (tile) {
      tile.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;   /* let the wishlist heart through */
        if (zimg) zimg.src = tile.getAttribute('data-mh-full');
        zoom.showModal();
      });
    });
    if (zclose) zclose.addEventListener('click', function () { zoom.close(); });
    zoom.addEventListener('click', function (e) { if (e.target === zoom) zoom.close(); });
  }
})();
